import { withRouter } from 'react-router-dom';
import FocusManager from './FocusManager';

export default withRouter(FocusManager);
